import Web3 from 'web3';
import {BN, HarmonyAddress} from "@harmony-js/crypto"
import {abi} from "./staking-abi";
import {Unit} from "@harmony-js/utils"

const CHAIN_ID_MAINNET = 900000
const CHAIN_ID_TESTNET = 910000
const CHAIN_ID_DEVNET = 920000

const isNetworkEqual = (networkConfig, metamaskChainId) => {
    if (networkConfig.id === 'posichain-mainnet' && metamaskChainId === CHAIN_ID_MAINNET) {
        return true
    }

    if (networkConfig.id === 'posichain-testnet' && metamaskChainId === CHAIN_ID_TESTNET) {
        return true
    }

    if (networkConfig.id === 'posichain-devnet' && metamaskChainId === CHAIN_ID_DEVNET) {
        return true
    }

    return false
}

export const processMetaMaskMessage = async (
    sendData,
    networkConfig,
    from
) => {
    const {type, fee, gasPrice: gasPriceData, validatorAddress, amount: amountData, amounts, toAddress} = sendData
    const {gasEstimate: gas} = fee
    // const { chain_id, rpc_url } = networkConfig //TODO: switch chain

    const web3URL = window.ethereum ? window.ethereum : process.env.HMY_NODE_URL;
    const hmyWeb3 = new Web3(web3URL);

    const web3Contract = new hmyWeb3.eth.Contract(abi, "0x00000000000000000000000000000000000000FC");

    const accounts = await window.ethereum.request({method: 'eth_requestAccounts'});

    // console.log(Unit.Szabo(amountData || 0).toHex());

    let amount;

    let result;
    let error;

    // const gas = 6721900;
    const gasPrice = Math.max(new BN(await hmyWeb3.eth.getGasPrice()).mul(new BN(1)).toNumber(), gasPriceData);

    try {
        const metamaskChainId = await hmyWeb3.eth.net.getId();
        if (!isNetworkEqual(networkConfig, metamaskChainId)) {
            throw new Error(`You are currently not on the ${networkConfig.title} network in Metamask.
                Please choose ${networkConfig.title} to continue.`);
        }

        switch (type) {
            case "MsgSend": {
                amount = Unit.Szabo(amountData || 0).toHex();
                result = await hmyWeb3.eth
                    .sendTransaction({
                        from: accounts[0],
                        to: new HarmonyAddress(toAddress).checksum,
                        value: Unit.Szabo(amounts[0].amount).toWei(),
                        gasPrice,
                        gas,
                    })
                    .on('error', console.error)
                    .on('transactionHash', transactionHash => {
                        console.log(`Transaction is sending: ${transactionHash}`);
                    });
                break
            }
            case "MsgDelegate": {
                amount = Unit.Szabo(amountData || 0).toHex();
                const method =  web3Contract.methods.Delegate(accounts[0], new HarmonyAddress(validatorAddress).checksum, amount);
                const gasEst =  await callEstGas(method, accounts[0]);

                result = await method.send({
                    from: accounts[0],
                    // value: amount,
                    gasPrice,
                    gas: gasEst,
                });
                break
            }
            case "MsgUndelegate": {
                amount = Unit.Szabo(amountData || 0).toHex();
              const method = web3Contract.methods.Undelegate(accounts[0], new HarmonyAddress(validatorAddress).checksum, amount)
              const gasEst = await  callEstGas(method, accounts[0]);

              result = await method.send({
                    from: accounts[0],
                    // value: amount,
                    gasPrice,
                    gas: gasEst,
                });

                break
            }
            case "MsgWithdrawDelegationReward": {
              const method = web3Contract.methods.CollectRewards(accounts[0])
              const gasEst = await callEstGas(method, accounts[0]);
              result = await method.send({
                    from: accounts[0],
                    gasPrice,
                    gas: gasEst,
                });
                break
            }
            default:
                break
        }
    } catch (e) {

        error = e;
    }

    return {
        included: async () => {
            if (!error && result && result.status === true) {
                return {txhash: result.transactionHash}
            } else {
                return {
                    error: true,
                    txhash: '',
                    message: error && error.message,
                }
            }
        }
    }
}

export const callEstGas = async (method, account, value = '0x0') => {
  try {
    const gas = await method.estimateGas({ from: account, value });
    const newGas = Number(gas) * 1.5;
    return Math.floor(newGas);
  } catch (err) {
      return 900000;
  }
};
